import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";
import {
  changeOwner,
  GetAllOrganizationsSingleCall,
  GetOrganizationById,
  getUser,
  changeMultipleOwner,
} from "../../../../../api";
import toast from "react-hot-toast";
import Select from "../../../../components/form/select";
import useUserStore from "../../../../stores/user";
import useApplicationStore from "../../../../stores/application";
import useCommonStore from "../../../../stores/common";
import config from "../../../../../config";

function ChangeOwner({
  open,
  onClose,
  fetchApplication = null,
  bulkAction = false,
  bulkActionProps = null,
  app = null
}) {
  const [isPCI, setIsPCI] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [users, setUsers] = useState([]);

  const [selectedOrg, setSelectedOrg] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const user = useUserStore((state) => state.user);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  let activeApp = app || useApplicationStore((state) => state.activeApp);
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);
  const selectedApps = useApplicationStore((state) => state.selectedApps);
  const orgId = user?.organization?.id;

  const handleOrgChange = async (orgId) => {
    setSelectedOrg(orgId);

    if (orgId !== "") {
      try {
        const res = await GetOrganizationById(orgId);

        let usersOptions = [];
        if (res.users && res.users.length > 0) {
          res.users.forEach((user) => {
            usersOptions.push({ label: user.name, value: user.id });
          });
        }

        setUsers(usersOptions);
      } catch (error) {
        console.log("error :>> ", error);
      }
    }
  };

  const handleUserChange = (selectedValues) => {
    setSelectedUser(selectedValues);
  };

  const handleSubmit = async () => {
    if (selectedUser !== "") {
      const toastId = toast.loading("Changing owner...");

      try {
        if (bulkAction) {
          const payload = {
            change_ownership_user_id: parseInt(selectedUser),
            stratus: true,
            ajaxRequest: true,
            ids: selectedApps,
          };
          const res = await changeMultipleOwner(payload);
          if (res.status) {
            toast.success("Owner is successfully changed", { id: toastId });
            bulkActionProps.fetchList();
            setShowDetails(false);
            bulkActionProps.close();
            setActiveApp(null);
          } else {
            toast.error("Something went wrong", { id: toastId });
          }
        } else {
          const payload = {
            change_ownership_user_id: parseInt(selectedUser),
            stratus: true,
            ajaxRequest: true,
            id: activeApp.id,
          };
          const res = await changeOwner(payload);
          if (res.status) {
            toast.success("Owner is successfully changed", { id: toastId });
            if (typeof fetchApplication === 'function') {
              fetchApplication();
            }
            onClose();
          } else {
            toast.error("Something went wrong", { id: toastId });
          }
        }
      } catch (error) {
        console.log("error :>> ", error);
        toast.error("Something went wrong", { id: toastId });
      }
    } else {
      toast.error("Please select organization and user");
      return;
    }
  };

  const isDisableButton = () => {
    if (isPCI) {
      return selectedOrg === "" || selectedUser === "";
    } else {
      return selectedUser === "";
    }
  };

  useEffect(() => {

    if (open && orgId) {
      const fetchOrganizations = async () => {
        try {
          const resUser = await getUser(orgId);
          const isPciTemp = resUser.is_pci;

          setIsPCI(resUser.is_pci);

          if (isPciTemp) {
            const res = await GetAllOrganizationsSingleCall();

            let orgsOptions = [];
            if (res.organization && res.organization.length) {
              orgsOptions = res.organization.map((organization) => {
                return {
                  label: organization.name,
                  value: organization.id,
                };
              });
            }
            setOrganizations(orgsOptions);
          } else {
            const usersList = resUser.user.map((organization) => {
              return {
                label: organization.name,
                value: organization.id,
              };
            });
            setUsers(usersList);
          }
        } catch (error) {
          console.log("error :>> ", error);
        }
      };

      fetchOrganizations();
    }
  }, [open, orgId, isPCI]);

  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Change owner</h6>

        {/* Show Select Organization to PCI users only */}
        {isPCI && (
          <div className={style.form_group}>
            <label htmlFor="owner">Select Organization</label>
            <Select
              placeholder="Select Organization"
              value={selectedOrg}
              onChange={handleOrgChange}
              options={organizations}
              search={true}
            />
          </div>
        )}

        {/* Show Select Users for PCI admin when organization is selected */}
        {(!isPCI || (isPCI && selectedOrg)) && (
          <div className={style.form_group}>
            <label htmlFor="owner">Select User</label>
            <Select
              placeholder="Select User"
              value={selectedUser}
              onChange={handleUserChange}
              options={users}
              search={true}
            />
          </div>
        )}
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            disabled={isDisableButton()}
            onClick={handleSubmit}
          >
            Submit
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default ChangeOwner;
